import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { ToastPosition } from 'react-bootstrap/ToastContainer';

import './ToastNotification.scss';

interface IToastNotification {
  toastContent: string;
  position?: ToastPosition;
  toastTitle: string;
  setToastContent: Dispatch<SetStateAction<string>>;
  setToastTitle: Dispatch<SetStateAction<string>>;
}

const ToastNotification: FC<IToastNotification> = ({
  toastContent,
  position,
  toastTitle,
  setToastContent,
  setToastTitle,
}) => {
  const [showToast, setShowToast] = useState<boolean>(false);
  useEffect(() => {
    if (toastContent) {
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setToastContent('');
        setToastTitle('');
      }, 5000);
    }
  }, [toastContent, setToastContent, toastTitle, setToastTitle]);
  return (
    <ToastContainer
      className="p-3 toast-container position-fixed"
      position={position ? position : 'top-end'}
    >
      <Toast show={showToast}>
        <Toast.Header closeButton={false}>
          <strong className="me-auto">{toastTitle}</strong>
        </Toast.Header>
        <Toast.Body>{toastContent}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastNotification;
